/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface BusinessCardApplicationRequest {
  /**
   * Идентификатор тарифа
   * @format uuid
   * @example 08330bdd-545e-4c1b-a812-5b2e7aa4e5f8
   */
  tariffId?: string;

  /**
   * Тип платежной системы
   * @example VISA
   */
  paySystem?: string;

  /**
   * Тип носителя карты
   * @example PLASTIC
   */
  issueType?: string;

  /**
   * Идентификатор счета для привязки бизнес карты
   * @format uuid
   * @example 0fa4b929-15fe-45c4-ad3f-5c8a498946fd
   */
  accountId?: string;

  /**
   * 0fa4b929-15fe-45c4-ad3f-5c8a498946fd
   * @format uuid
   * @example 0fa4b929-15fe-45c4-ad3f-5c8a498946fd
   */
  delegateId?: string;

  /**
   * Имя и фамилия латиницей для карты для эмбоссирования
   * @example TRETIAKOV ALEKSEI
   */
  embossingFio?: string;

  /**
   * Название организации для эмбоссирования
   * @example BEST SOFT
   */
  embossingOrganisation?: string;

  /**
   * Кодовое слово
   * @example SECRET
   */
  secretWord?: string;

  /**
   * Номер для СМС уведомлений
   * @example +79261234567
   */
  notificationPhone?: string;

  /**
   * Где забирать карту
   * @example Адрес отделения выдачи карты
   */
  issueBranch?: string;

  /**
   * Для ориенировки по страничкам заявки
   * @example DRAFT
   */
  status?:
    | "NEW"
    | "DRAFT"
    | "ON_CONFIRMATION"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "SENT_TO_CRM"
    | "SENT_TO_PROCESSING"
    | "SENT_TO_VERIFICATION"
    | "ON_VERIFICATION"
    | "DECLINED"
    | "REGISTERED_IN_CRM"
    | "COMPLETED"
    | "ERROR";

  /** Сущность держателя карты - третьего лица */
  thirdPerson?: ThirdPerson;

  /** Сущность лимитов выбранных в заявке */
  cardLimits?: CardLimits;
}

/**
 * Сущность лимитов выбранных в заявке
 */
export interface CardLimits {
  /** Сумма наличных (ежедневный лимит) */
  dailyCashAmount?: number;

  /** Сумма покупок (ежедневный лимит) */
  dailyPurchaseAmount?: number;

  /** Сумма переводов (ежедневный лимит) */
  dailyTransferAmount?: number;

  /** Общая сумма (ежедневный лимит) */
  dailyTotalAmount?: number;

  /** Сумма наличных (ежемесячный лимит) */
  monthlyCashAmount?: number;

  /** Сумма покупок (ежемесячный лимит) */
  monthlyPurchaseAmount?: number;

  /** Сумма переводов (ежемесячный лимит) */
  monthlyTransferAmount?: number;

  /** Общая сумма (ежемесячный лимит) */
  monthlyTotalAmount?: number;
}

/**
 * Сущность держателя карты - третьего лица
 */
export interface ThirdPerson {
  /**
   * Фамилия держателя карты
   * @example Третьяков
   */
  lastName: string;

  /**
   * Имя держателя карты
   * @example Алексей
   */
  firstName: string;

  /**
   * Отчество держателя карты
   * @example Александрович
   */
  middleName?: string;

  /**
   * Дата рождения
   * @format date
   */
  birthDate: string;

  /**
   * Пол
   * @example M
   */
  gender: string;

  /**
   * Гражданство
   * @example Российская Федерация
   */
  citizenship: string;

  /**
   * Тип документа удостоверяющего личность
   * @example Паспорт
   */
  dulType: string;

  /**
   * Серия документа удостоверяющего личность
   * @example 4516
   */
  dulSeries: string;

  /**
   * Номер документа удостоверяющего личность
   * @example 345200
   */
  dulNumber: string;

  /**
   * Кем выдан документ удостоверяющий личность
   * @example УФМС России
   */
  dulIssueDepartment: string;

  /**
   * Когда выдан документ удостоверяющий личность
   * @format date
   */
  dulIssueDate: string;

  /**
   * Код подразделения
   * @example 200-703
   */
  dulCodeDepartment: string;

  /** Сущность адресса регистрации держателя карты */
  actualAddress?: ThirdPersonAddress;

  /** Сущность адресса регистрации держателя карты */
  registrationAddress?: ThirdPersonAddress;
}

/**
 * Сущность адресса регистрации держателя карты
 */
export interface ThirdPersonAddress {
  /**
   * Адрес строкой
   * @example г. Москва
   */
  fullAddress: string;

  /**
   * Населенный пункт
   * @example Москва
   */
  populationCenter: string;

  /**
   * Улица
   * @example Богданова
   */
  street: string;

  /**
   * Дом
   * @example 32
   */
  house: string;

  /**
   * Корпус
   * @example 2
   */
  building?: string;

  /**
   * Строение
   * @example 3
   */
  housing?: string;

  /**
   * Квартира
   * @example 3
   */
  flat?: string;

  /**
   * Страна
   * @example Россия
   */
  country: string;

  /**
   * Регион
   * @example 77
   */
  region: string;

  /**
   * Тип адреса
   * @example ACTUAL_ADDRESS
   */
  addressType?: string;
}

/**
 * Счет клиента
 */
export interface Account {
  /**
   * Идентификатор счета
   * @format uuid
   * @example 123e4567-e89b-12d3-a456-426614173467
   */
  id: string;

  /**
   * Номер карты
   * @example 47423810835000024948
   */
  number: string;

  /**
   * Наименование
   * @example ООО БРИТВА(требование по комиссиям РКО)
   */
  name: string;

  /**
   * Валюта
   * @example RUR
   */
  currency: string;

  /**
   * Признак наличия договора РКО
   * @example true
   */
  hasRkoContract: boolean;

  /**
   * Текущий остаток в валюте счета
   * @example -123456789.99
   */
  balance?: number;

  /**
   * Тип счета (расчетный, депозитный, etc)
   * @example Не определен
   */
  type?: string;
}

export interface BusinessCardApplicationResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   * @example 866e54c4-4566-4c58-8663-0c2d9f129e0d
   */
  id?: string;

  /**
   * Подписано первой подписью
   * @example true
   */
  clientFirstSign?: boolean;

  /**
   * Подписано второй подписью
   * @example false
   */
  clientSecondSign?: boolean;

  /**
   * Дата создания заявки
   * @format date-time
   */
  createdAt?: string;

  /**
   * Дата последнего обновления заявки
   * @format date-time
   */
  updatedAt?: string;

  /**
   * Статус заявки
   * @example ON_CONFIRMATION
   */
  status?:
    | "NEW"
    | "DRAFT"
    | "ON_CONFIRMATION"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "SENT_TO_CRM"
    | "SENT_TO_PROCESSING"
    | "SENT_TO_VERIFICATION"
    | "ON_VERIFICATION"
    | "DECLINED"
    | "REGISTERED_IN_CRM"
    | "COMPLETED"
    | "ERROR";

  /**
   * Описание ошибки
   * @example ERROR:1:Ошибка при загрузке файла
   */
  errorDescription?: string;

  /**
   * Эмбасированное фио
   * @example TRETIAKOV ALEKSEI
   */
  embossingFio?: string;

  /**
   * Эмбасированная организация
   * @example BEST SOFT
   */
  embossingOrganisation?: string;

  /**
   * Отделение выдачи бизнес карты
   * @example Адрес выдачи карты
   */
  issueBranch?: string;

  /**
   * Номер телефона для получения уведомлений
   * @example +79261234567
   */
  notificationPhone?: string;

  /** Сущность клиента - ЮЛ */
  client?: Client;

  /** Делегат */
  delegate?: Delegate;

  /** Сущность держателя карты - третьего лица */
  thirdPerson?: ThirdPerson;

  /** Счет клиента */
  account?: Account;

  /** Платёжная система */
  paymentSystem?: PaymentSystem;

  /** Тип карты */
  issueType?: IssueType;

  /** Тариф */
  tariff?: Tariff;

  /** Сущность лимитов выбранных в заявке */
  limits?: CardLimits;
}

/**
 * Сущность клиента - ЮЛ
 */
export interface Client {
  /**
   * Идентификатор клиента
   * @format uuid
   * @example a195b8ff-b3db-4a00-b066-d2c2257d0864
   */
  id: string;

  /**
   * Страна клиента
   * @example Россия
   */
  country?: string;

  /**
   * Короткое имя клиента
   * @example ООО "ЗЕБРА"
   */
  shortName?: string;

  /**
   * Полное имя организации латиницей
   * @example OOO 'ZEBRA'
   */
  fullNameLatin?: string;

  /**
   * Полный адресс строкой
   * @example 190000, г Санкт-Петербург, пр-кт Королёва, дом 63, оф. 1
   */
  addressStr?: string;

  /**
   * ИНН клиента
   * @example 352831622163
   */
  inn?: string;

  /**
   * Отделение обслуживания клиента
   * @example 3500
   */
  branchCode?: string;
}

/**
 * Делегат
 */
export interface Delegate {
  /**
   * Индетификатор делегата
   * @format uuid
   * @example 866e54c4-4566-4c58-8663-0c2d9f129e0d
   */
  id: string;

  /**
   * Индетификатор cio
   * @example 300233468523
   */
  cioId: string;

  /**
   * ФИО делегата
   * @example Иванов Иван Иванович
   */
  fullName: string;

  /**
   * Номер телефона делегата
   * @example +7 (932) 786-44-33
   */
  phone?: string;

  /**
   * ФИ делегата латиницей
   * @example IVAN IVANOV
   */
  latinName?: string;

  /**
   * Наименование организации латиницей без ОПФ
   * @example BEST SOFT
   */
  latinCompanyName?: string;
}

/**
 * Тип карты
 */
export interface IssueType {
  /**
   * Код типа карты
   * @example PLASTIC
   */
  code: string;

  /**
   * Заголовок типа карты
   * @example Пластиковая карта
   */
  title: string;

  /**
   * Описание типа карты
   * @example Описание пластиковой карты
   */
  description: string;
}

/**
 * Платёжная система
 */
export interface PaymentSystem {
  /**
   * Код платежной системы
   * @example VISA
   */
  code: string;

  /**
   * Заголовок платежной системы
   * @example Платёжная система VISA
   */
  title?: string;

  /**
   * Описание платежной системы
   * @example Описание платёжной системы VISA
   */
  description?: string;
}

/**
 * Тариф
 */
export interface Tariff {
  /**
   * Идентификатор тарифа
   * @format uuid
   */
  id?: string;

  /** Заголовок тарифа */
  title: string;

  /** Описание тарифа */
  description: string;

  /** Назначение тарифа */
  purpose: string;

  /** Ссылка на тариф */
  link: string;

  /** Цвет заливки тарифа */
  backgroundColor?: string;

  /** Флаг активности тарифа */
  enabled: boolean;

  /** Фичи тарифа */
  features?: string;

  /** Список платёжных систем тарифа */
  tariffPaymentSystems?: TariffExtendedPaymentSystem[];
}

/**
 * Расширенная платёжная система тарифа
 */
export interface TariffExtendedPaymentSystem {
  /** Платёжная система */
  paymentSystem: PaymentSystem;

  /** ЦФТ код тарифа и платёжной системы */
  cftCode: string;

  /** Типы выпуска карт */
  issueTypes: IssueType[];
}

/**
 * Сообщение об ошибке
 */
export interface ErrorMessage {
  /** Название ошибки */
  name: string;

  /** Описание ошибки */
  description: string;

  /** Дата и время возникновения ошибки */
  timestamp: string;
}

/**
 * Бизнес-карта клиента
 */
export interface Card {
  /**
   * Идентификатор карты
   * @example PknKgAQ3
   */
  id?: string;

  /**
   * Идентификатор тарифа
   * @format uuid
   * @example 08330bdd-545e-4c1b-a812-5b2e7aa4e5f8
   */
  tariffId?: string;

  /**
   * Идентификатор  счета
   * @format uuid
   * @example 08330bdd-545e-4c1b-a812-5b2e7aa4e5f8
   */
  accountId?: string;

  /**
   * ФИО держателя карты
   * @example Иванов Иван Иванович
   */
  holderFullName: string;

  /**
   * Описание карты
   * @example Цифровая дебетовая бизнес-карта
   */
  cardDescription: string;

  /**
   * Маскированный номер карты
   * @example 5555 55** **** 5555
   */
  maskedCardNumber: string;

  /**
   * Срок действия
   * @example 05/2022
   */
  validity: string;

  /** Статус карты клиента */
  status: CardStatus;

  /**
   * Платёжная система
   * @example VISA
   */
  paymentSystem?: string;

  /**
   * Тип карты
   * @example PLASTIC
   */
  issueType?: "VIRTUAL" | "DIGITAL" | "PLASTIC";

  /**
   * Доступный остаток на счете карты
   * @example -123456789.99
   */
  availableBalance?: number;

  /**
   * Валюта карточного счёта
   * @example RUR
   */
  currency?: string;

  /** Разрешённые действия с картой */
  permissions?: Record<string, boolean>;
}

/**
 * Статус карты клиента
 */
export interface CardStatus {
  /**
   * Человекочитаемое описание статуса
   * @example В процессе выполнения
   */
  title: string;

  /**
   * Состояние статуса
   * @example ACTIVE
   */
  condition: "ACTIVE" | "NOT_ACTIVE" | "CLOSED" | "HAS_PROBLEMS";
}

export interface TransferBetweenCardsApplicationResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   * @example a195b8ff-b3db-4a00-b066-d2c2257d0864
   */
  id: string;

  /**
   * Подписано первой подписью
   * @example true
   */
  clientFirstSign?: boolean;

  /**
   * Подписано второй подписью
   * @example false
   */
  clientSecondSign?: boolean;

  /**
   * Дата создания заявки
   * @format date-time
   */
  createdAt?: string;

  /**
   * Дата последнего обновления заявки
   * @format date-time
   */
  updatedAt?: string;

  /**
   * Статус заявки
   * @example ON_CONFIRMATION
   */
  status?:
    | "NEW"
    | "DRAFT"
    | "ON_CONFIRMATION"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "SENT_TO_CRM"
    | "SENT_TO_PROCESSING"
    | "SENT_TO_VERIFICATION"
    | "ON_VERIFICATION"
    | "DECLINED"
    | "REGISTERED_IN_CRM"
    | "COMPLETED"
    | "ERROR";

  /**
   * Описание ошибки
   * @example ERROR:1:Ошибка при загрузке файла
   */
  errorDescription?: string;

  /** Сущность клиента - ЮЛ */
  client?: Client;

  /** Сумма перевода */
  transferAmount?: number;

  /** Бизнес-карта клиента */
  card?: Card;

  /** Идентификатор карты получателя */
  recipientCardId?: string;

  /** Счет клиента */
  account?: Account;

  /** Сумма комиссии */
  commissionAmount?: number;

  /**
   * Тип перевода
   * @format int32
   */
  trxType?: number;

  /** Маскированный номер карты получателя */
  maskedDstCardNumber?: string;

  /** Уникальный номер операции */
  operationId?: string;

  /** Идентификатор транзакции */
  transactionId?: string;

  /** Назначение платежа при переводах B2B */
  ground?: string;
}

export interface TransferBetweenCardsApplicationRequest {
  /**
   * Идентификатор карты отправителя
   * @example Fj324FK
   */
  senderCardId: string;

  /** Идентификатор карты получателя */
  recipientCardId: string;

  /** Сумма перевода */
  transferAmount: number;

  /** Сумма комиссии */
  commissionAmount: number;

  /** Идентификатор операции */
  operationId: string;

  /** Идентификатор транзакции */
  transactionId: string;

  /**
   * Тип перевода
   * @format int32
   */
  trxType: number;

  /** Номер карты получателя */
  recipientCardNumber: string;

  /** Назначение платежа при переводах B2B */
  ground?: string;
}

export interface CheckTransferBetweenCardsRequest {
  /**
   * Идентификатор карты отправителя
   * @example Fj324FK
   */
  senderCardId: string;

  /**
   * Идентификатор карты получателя
   * @example asdad324
   */
  recipientCardId: string;

  /** Сумма перевода */
  transferAmount: number;

  /**
   * Тип перевода
   * @format int32
   */
  trxType: number;

  /**
   * Назначение платежа
   * @example Перевод за услуги
   */
  ground?: string;
}

export interface CheckTransferBetweenCardsResponse {
  /** Сумма перевода */
  transferAmount: number;

  /** Размер комиссии банка */
  commissionAmount?: number;

  /** Идентификатор операции */
  operationId: string;

  /** Идентификатор транзакции */
  transactionId: string;
}

export interface SelfEncashmentApplicationResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   * @example 866e54c4-4566-4c58-8663-0c2d9f129e0d
   */
  id?: string;

  /** Сущность клиента - ЮЛ */
  client?: Client;

  /** Счет клиента */
  account?: Account;

  /** Счет клиента */
  fundAccount?: Account;

  /**
   * Дата создания заявки
   * @format date-time
   */
  createdAt?: string;

  /**
   * Дата последнего обновления заявки
   * @format date-time
   */
  updatedAt?: string;

  /**
   * Статус заявки
   * @example ON_CONFIRMATION
   */
  status?:
    | "NEW"
    | "DRAFT"
    | "ON_CONFIRMATION"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "SENT_TO_CRM"
    | "SENT_TO_PROCESSING"
    | "SENT_TO_VERIFICATION"
    | "ON_VERIFICATION"
    | "DECLINED"
    | "REGISTERED_IN_CRM"
    | "COMPLETED"
    | "ERROR";

  /**
   * Тип заявки
   * @example DISABLE
   */
  type?: "ENABLE" | "UPDATE" | "DISABLE";

  /**
   * Подписано первой подписью
   * @example true
   */
  clientFirstSign?: boolean;

  /**
   * Подписано второй подписью
   * @example false
   */
  clientSecondSign?: boolean;

  /**
   * Текст ошибки при статусе ERROR
   * @example Ошибка при получении данных из CRM
   */
  errorDescription?: string;
}

export interface SelfEncashmentApplicationRequest {
  /** @format uuid */
  accountId: string;

  /** @format uuid */
  fundAccountId: string;
}

export interface LockCloseApplicationResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   * @example a195b8ff-b3db-4a00-b066-d2c2257d0864
   */
  id: string;

  /**
   * Подписано первой подписью
   * @example true
   */
  clientFirstSign?: boolean;

  /**
   * Подписано второй подписью
   * @example false
   */
  clientSecondSign?: boolean;

  /**
   * Дата создания заявки
   * @format date-time
   */
  createdAt?: string;

  /**
   * Дата последнего обновления заявки
   * @format date-time
   */
  updatedAt?: string;

  /**
   * Статус заявки
   * @example ON_CONFIRMATION
   */
  status?:
    | "NEW"
    | "DRAFT"
    | "ON_CONFIRMATION"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "SENT_TO_CRM"
    | "SENT_TO_PROCESSING"
    | "SENT_TO_VERIFICATION"
    | "ON_VERIFICATION"
    | "DECLINED"
    | "REGISTERED_IN_CRM"
    | "COMPLETED"
    | "ERROR";

  /**
   * Описание ошибки
   * @example ERROR:1:Ошибка при загрузке файла
   */
  errorDescription?: string;

  /** Подтип заявки (блокировка/закрытие) */
  subtype: "LOCK_APPLICATION" | "CLOSE_APPLICATION";

  /**
   * Причина блокировки/закрытия карты
   * @example Утеря карты
   */
  reason?: string;

  /** Сущность клиента - ЮЛ */
  client?: Client;

  /** Бизнес-карта клиента */
  card?: Card;

  /** Счет клиента */
  account?: Account;
}

export interface LockCloseApplicationRequest {
  /**
   * Идентификатор карты для обновления лимитов
   * @example Fj324FK
   */
  cardId: string;

  /** Подтип заявки (блокировка/закрытие) */
  subType: "LOCK_APPLICATION" | "CLOSE_APPLICATION";

  /**
   * Причина блокировки/закрытия карты
   * @example Утеря карты
   */
  reason?: string;
}

export interface LimitsApplicationResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   * @example a195b8ff-b3db-4a00-b066-d2c2257d0864
   */
  id: string;

  /**
   * Подписано первой подписью
   * @example true
   */
  clientFirstSign?: boolean;

  /**
   * Подписано второй подписью
   * @example false
   */
  clientSecondSign?: boolean;

  /**
   * Дата создания заявки
   * @format date-time
   */
  createdAt?: string;

  /**
   * Дата последнего обновления заявки
   * @format date-time
   */
  updatedAt?: string;

  /**
   * Статус заявки
   * @example ON_CONFIRMATION
   */
  status?:
    | "NEW"
    | "DRAFT"
    | "ON_CONFIRMATION"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "SENT_TO_CRM"
    | "SENT_TO_PROCESSING"
    | "SENT_TO_VERIFICATION"
    | "ON_VERIFICATION"
    | "DECLINED"
    | "REGISTERED_IN_CRM"
    | "COMPLETED"
    | "ERROR";

  /**
   * Описание ошибки
   * @example ERROR:1:Ошибка при загрузке файла
   */
  errorDescription?: string;

  /** Сущность клиента - ЮЛ */
  client?: Client;

  /** Сущность лимитов выбранных в заявке */
  limits?: CardLimits;

  /** Бизнес-карта клиента */
  card?: Card;

  /** Счет клиента */
  account?: Account;
}

export interface LimitsApplicationRequest {
  /**
   * Идентификатор карты для обновления лимитов
   * @example Fj324FK
   */
  cardId: string;

  /** Сущность лимитов выбранных в заявке */
  limits: CardLimits;
}

export interface ChangePinApplicationSendRequest {
  /**
   * Идентификатор заявки на изменение ПИН-кода
   * @format uuid
   * @example a195b8ff-b3db-4a00-b066-d2c2257d0864
   */
  applicationId: string;

  /** Данные для изменения ПИН-кода */
  changePinData?: ChangePinData;
}

/**
 * Данные для изменения ПИН-кода
 */
export interface ChangePinData {
  /**
   * ПИН-код, зашифрованный открытым ключом ПЦ по алгоритму RSA/ECB/PKCS1Padding в кодировке base64
   * @example 3ZHTWS7F999CN323FFNJBE788=
   */
  newPin: string;

  /**
   * Идентификатор ключа шифрования
   * @example 12345
   */
  keyId: string;
}

export interface ChangePinApplicationResponse {
  /**
   * Идентификатор заявки на изменение ПИН-кода
   * @format uuid
   * @example a195b8ff-b3db-4a00-b066-d2c2257d0864
   */
  id: string;

  /**
   * Статус заявки
   * @example COMPLETED
   */
  status?:
    | "NEW"
    | "DRAFT"
    | "ON_CONFIRMATION"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "SENT_TO_CRM"
    | "SENT_TO_PROCESSING"
    | "SENT_TO_VERIFICATION"
    | "ON_VERIFICATION"
    | "DECLINED"
    | "REGISTERED_IN_CRM"
    | "COMPLETED"
    | "ERROR";

  /**
   * Описание ошибки
   * @example Невозможно изменить ПИН-код
   */
  errorDescription?: string;

  /**
   * Дата создания заявки
   * @format date-time
   */
  createdAt?: string;

  /**
   * Дата последнего обновления заявки
   * @format date-time
   */
  updatedAt?: string;

  /**
   * Человекочитаемое описание результата работы
   * @example ПИН-код изменён
   */
  humanReadableMessage?: string;

  /** Сущность клиента - ЮЛ */
  client?: Client;

  /** Бизнес-карта клиента */
  card?: Card;

  /** Счет клиента */
  account?: Account;
}

export interface ChangePinApplicationRequest {
  /**
   * Идентификатор карты для изменения ПИН-кода
   * @example Fj324FK
   */
  cardId: string;
}

/**
 * Ответ с результатом загрузки вложений
 */
export interface AttachmentLoadInfo {
  /**
   * Внутренний идентификатор вложения
   * @format uuid
   * @example 1ae9a714-141f-4840-98f9-2f858ea65fd6
   */
  id: string;

  /**
   * Имя файла
   * @example Паспорт.jpg
   */
  fileName: string;

  /**
   * Идентификатор вложения в ЭП РСХБ
   * @format uuid
   */
  eprshbExternalId: string;

  /**
   * Статус загрузки вложения в ЭП РСХБ
   * @example COMPLETED
   */
  state: "LOADING" | "REJECTED" | "ERROR" | "TIMEOUT" | "COMPLETED";

  /**
   * Текст ошибки загрузки вложения в ЭП РСХБ
   * @example Текст ошибки
   */
  errorDescription?: string;

  /** Хэш вложения */
  hash?: string;
}

/**
 * Ответ с результатом загрузки вложений
 */
export interface AttachmentLoadResponse {
  attachmentsLoadInfo: AttachmentLoadInfo[];
}

/**
 * Статус заявки
 */
export interface ApplicationStatusResponse {
  status:
    | "NEW"
    | "DRAFT"
    | "ON_CONFIRMATION"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "SENT_TO_CRM"
    | "SENT_TO_PROCESSING"
    | "SENT_TO_VERIFICATION"
    | "ON_VERIFICATION"
    | "DECLINED"
    | "REGISTERED_IN_CRM"
    | "COMPLETED"
    | "ERROR";
}

/**
 * Список тарифов
 */
export interface TariffResponse {
  tariffs: Tariff[];
}

export interface BaseSelfEncashmentApplicationResponse {
  /**
   * Идентификатор заявки
   * @format uuid
   * @example 866e54c4-4566-4c58-8663-0c2d9f129e0d
   */
  id?: string;

  /** Счет для привязки услуги */
  account?: string;

  /** Счет пополнения */
  fundAccount?: string;

  /**
   * Дата создания заявки
   * @format date-time
   */
  createdAt?: string;

  /**
   * Дата последнего обновления заявки
   * @format date-time
   */
  updatedAt?: string;

  /**
   * Статус заявки
   * @example ON_CONFIRMATION
   */
  status?:
    | "NEW"
    | "DRAFT"
    | "ON_CONFIRMATION"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "SENT_TO_CRM"
    | "SENT_TO_PROCESSING"
    | "SENT_TO_VERIFICATION"
    | "ON_VERIFICATION"
    | "DECLINED"
    | "REGISTERED_IN_CRM"
    | "COMPLETED"
    | "ERROR";

  /**
   * Тип заявки
   * @example DISABLE
   */
  type?: string;

  /**
   * Подписано первой подписью
   * @example true
   */
  clientFirstSign?: boolean;

  /**
   * Подписано второй подписью
   * @example false
   */
  clientSecondSign?: boolean;

  /**
   * Текст ошибки при статусе ERROR
   * @example Ошибка при получении данных из CRM
   */
  errorDescription?: string;

  /**
   * Короткое имя клиента
   * @example ООО "ЗЕБРА"
   */
  clientName?: string;

  /**
   * ИНН клиента
   * @example 352831622163
   */
  clientInn?: string;

  /**
   * Отделение обслуживания клиента
   * @example 3500
   */
  clientBranchCode?: string;
}

export interface PageableObject {
  /** @format int64 */
  offset?: number;
  sort?: SortObject[];
  paged?: boolean;

  /** @format int32 */
  pageNumber?: number;

  /** @format int32 */
  pageSize?: number;
  unpaged?: boolean;
}

/**
 * Страница с заявками на бизнес-карты клиента
 */
export interface SelfEncashmentApplicationPage {
  content?: BaseSelfEncashmentApplicationResponse[];
  pageable?: PageableObject;

  /** @format int64 */
  total?: number;
  last?: boolean;

  /** @format int32 */
  totalPages?: number;

  /** @format int64 */
  totalElements?: number;
  first?: boolean;

  /** @format int32 */
  size?: number;

  /** @format int32 */
  number?: number;
  sort?: SortObject[];

  /** @format int32 */
  numberOfElements?: number;
  empty?: boolean;
}

export interface SortObject {
  direction?: string;
  nullHandling?: string;
  ascending?: boolean;
  property?: string;
  ignoreCase?: boolean;
}

/**
 * Список счетов клиента
 */
export interface AccountResponse {
  accounts: Account[];
}

/**
 * Счет клиента
 */
export interface SelfEncashmentAccount {
  /**
   * Идентификатор счёта
   * @format uuid
   * @example 123e4567-e89b-12d3-a456-426614173467
   */
  id: string;

  /**
   * Номер счёта
   * @example 47423810835000024948
   */
  number: string;

  /**
   * Статус услуги "Самоинкассация"
   * @example CONNECTED
   */
  status: "CONNECTED" | "NOT_CONNECTED";

  /**
   * Идентификатор счёта для зачисления денежных средств
   * @format uuid
   * @example 123e4567-e89b-12d3-a456-426614173467
   */
  fundAccountId?: string;

  /**
   * Номер счёта для зачисления денежных средств
   * @example 47423810835000024333
   */
  fundAccountNumber?: string;

  /**
   * Количество карт, открытых к счёту
   * @format int32
   * @example 12
   */
  cardsCount: number;

  /**
   * Флаг возможности подключения услуги "Самоинкассация"
   * @example false
   */
  connectionAllowed: boolean;

  /**
   * Флаг возможности отключения услуги "Самоинкассация"
   * @example true
   */
  disconnectionAllowed: boolean;
}

/**
 * Список счетов клиента с данными по самоинкассации
 */
export interface SelfEncashmentAccountResponse {
  accounts: SelfEncashmentAccount[];
}

/**
 * Список платежных систем
 */
export interface PaymentSystemResponse {
  paymentSystems: PaymentSystem[];
}

/**
 * Список типов карты
 */
export interface IssueTypeResponse {
  issueTypes: IssueType[];
}

/**
 * Ответ с текущими данными по подписанию
 */
export interface SignDataResponse {
  /**
   * Необходимое количество подписей
   * @format int32
   * @example 2
   */
  signCount: number;

  /**
   * Сигнатура текущего пользователя
   * @example ClientFirstSign
   */
  authoritySignature: string;
}

/**
 * Документ с типом и полями
 */
export interface ApplicationDocumentTransferBetweenCardsApplicationCcb {
  /** Тип документа */
  type: DocumentType;

  /** Поля документа */
  fields: TransferBetweenCardsApplicationCcb;
}

/**
 * Тип документа
 */
export interface DocumentType {
  name: string;
  desc: string;
}

/**
 * Поля документа
 */
export interface TransferBetweenCardsApplicationCcb {
  id: string;

  /** Сумма перевода */
  transferAmount: number;
  maskedCardNumber: string;

  /** Идентификатор карты получателя */
  dstCardId: string;

  /** Сумма комиссии */
  commissionAmount: string;

  /**
   * Тип перевода
   * @format int32
   */
  trxType: number;

  /** Маскированный номер карты получателя */
  maskedDstCardNumber: string;

  /** Уникальный номер операции */
  operationId?: string;

  /** Идентификатор транзакции */
  transactionId?: string;
}

/**
 * Получение ККБ заявки на перевод денежных средств по номеру банковской карты с использованием реквизитов бизнес-карты
 */
export interface TransferBetweenCardsApplicationDocumentCcbResponse {
  /** ККБ */
  ccb: string;

  /** Версия ККБ */
  ccbVersion: string;

  /** Документ с типом и полями */
  document: ApplicationDocumentTransferBetweenCardsApplicationCcb;
}

/**
 * Документ с типом и полями
 */
export interface ApplicationDocumentSelfEncashmentApplicationCcb {
  /** Тип документа */
  type: DocumentType;

  /** Поля документа */
  fields: SelfEncashmentApplicationCcb;
}

/**
 * Поля документа
 */
export interface SelfEncashmentApplicationCcb {
  id: string;
  accountNumber: string;
  fundAccountNumber: string;
  type: string;
}

/**
 * Получение ККБ конкретной заявки на подключение самоинкассации
 */
export interface SelfEncashmentApplicationDocumentCcbResponse {
  /** ККБ */
  ccb: string;

  /** Версия ККБ */
  ccbVersion: string;

  /** Документ с типом и полями */
  document: ApplicationDocumentSelfEncashmentApplicationCcb;
}

/**
 * Документ с типом и полями
 */
export interface ApplicationDocumentLockCloseApplicationCcb {
  /** Тип документа */
  type: DocumentType;

  /** Поля документа */
  fields: LockCloseApplicationCcb;
}

/**
 * Поля документа
 */
export interface LockCloseApplicationCcb {
  id: string;
  maskedCardNumber: string;
  subtype?: string;
  reason?: string;
}

/**
 * Получение ККБ конкретной заявки на блокировку/закрытие бизнес-карты
 */
export interface LockCloseApplicationDocumentCcbResponse {
  /** ККБ */
  ccb: string;

  /** Версия ККБ */
  ccbVersion: string;

  /** Документ с типом и полями */
  document: ApplicationDocumentLockCloseApplicationCcb;
}

/**
 * Документ с типом и полями
 */
export interface ApplicationDocumentLimitsApplicationCcb {
  /** Тип документа */
  type: DocumentType;

  /** Поля документа */
  fields: LimitsApplicationCcb;
}

/**
 * Поля документа
 */
export interface LimitsApplicationCcb {
  id: string;
  maskedCardNumber: string;
  dailyCashAmount?: string;
  dailyPurchaseAmount?: string;
  dailyTransferAmount?: string;
  dailyTotalAmount?: string;
  monthlyCashAmount?: string;
  monthlyPurchaseAmount?: string;
  monthlyTransferAmount?: string;
  monthlyTotalAmount?: string;
}

/**
 * Получение ККБ конкретной заявки на изменение лимитов по бизнес-карте
 */
export interface LimitsApplicationDocumentCcbResponse {
  /** ККБ */
  ccb: string;

  /** Версия ККБ */
  ccbVersion: string;

  /** Документ с типом и полями */
  document: ApplicationDocumentLimitsApplicationCcb;
}

/**
 * Документ с типом и полями
 */
export interface ApplicationDocumentBusinessCardApplicationCcb {
  /** Тип документа */
  type: DocumentType;

  /** Поля документа */
  fields: BusinessCardApplicationCcb;
}

/**
 * Поля документа
 */
export interface BusinessCardApplicationCcb {
  id: string;
  tariffTitle: string;
  paySystem: string;
  issueType: string;
  accountNumber: string;
  cardHolderFullName: string;
  embossingFio: string;
  embossingOrganisation: string;
  notificationPhone: string;
  issueBranch: string;

  /** @format date */
  birthDate?: string;
  gender?: string;
  citizenship?: string;
  dul?: string;
  registrationAddress?: string;
  actualAddress?: string;
  dailyCashAmount?: string;
  dailyPurchaseAmount?: string;
  dailyTransferAmount?: string;
  dailyTotalAmount?: string;
  monthlyCashAmount?: string;
  monthlyPurchaseAmount?: string;
  monthlyTransferAmount?: string;
  monthlyTotalAmount?: string;
}

/**
 * Получение ККБ конкретной заявки на бизнес-карту
 */
export interface BusinessCardApplicationDocumentCcbResponse {
  /** ККБ */
  ccb: string;

  /** Версия ККБ */
  ccbVersion: string;

  /** Документ с типом и полями */
  document: ApplicationDocumentBusinessCardApplicationCcb;
}

/**
 * Ответ с типом подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType: string;
}

/**
 * Сведения о карте отправителя для которой доступен перевод по номеру карты
 */
export interface CardForTransferBetweenCards {
  id?: string;

  /** @format uuid */
  accountId?: string;
  accountNumber?: string;
  currency?: string;
  availableBalance?: number;

  /** @format uuid */
  tariffId?: string;
  maskedCardNumber?: string;
  paymentSystem?: string;
  cardDescription?: string;
  validity?: string;
}

/**
 * Сведения о картах отправителя для которых доступен перевод по номеру карты
 */
export interface CardsForTransferBetweenCards {
  cards: CardForTransferBetweenCards[];
}

/**
 * Страница с бизнес-картами клиента
 */
export interface CardsPage {
  content?: Card[];
  pageable?: PageableObject;

  /** @format int64 */
  total?: number;
  last?: boolean;

  /** @format int32 */
  totalPages?: number;

  /** @format int64 */
  totalElements?: number;
  first?: boolean;

  /** @format int32 */
  size?: number;

  /** @format int32 */
  number?: number;
  sort?: SortObject[];

  /** @format int32 */
  numberOfElements?: number;
  empty?: boolean;
}

/**
 * Данные по лимитам на бизнес-карте
 */
export interface CardLimitsResponse {
  /** Сущность лимитов выбранных в заявке */
  installedLimits?: CardLimits;

  /** Сущность лимитов выбранных в заявке */
  bankLimits?: CardLimits;
}

/**
 * Данные по бизнес-карте
 */
export interface CardDetailsResponse {
  /**
   * Зашифрованная строка с данными
   * @example eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ
   */
  encodeCardData?: string;
}

export interface GetCardPropertiesByCardNumberResponse {
  /** Идентификатор карты получателя */
  cardId: string;

  /**
   * Тип перевода
   * @format int32
   */
  trxType: number;

  /** Признак бизнес-карты назначения */
  destCardBusiness?: boolean;
}

export interface ChangePinInfo {
  /**
   * Открытый ключ RSA, полученный от процессинга для шифрования ПИН-кода
   * @example 1234567890ABCDEF
   */
  publicKey: string;

  /**
   * Идентификатор ключа шифрования
   * @example 12345
   */
  keyId: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial: string;

  /** Имя эмитента сертификата (центра сертификации) */
  issuer: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId: string;

  /**
   * Идентификатор клиента ДБО ЮЛ
   * @format uuid
   */
  clientId: string;
}

/**
 * Данные операции на бизнес-карте
 */
export interface CardOperation {
  /** Идентификатор операции */
  refNumber: string;

  /**
   * Дата и время совершения операции по карте
   * @format date-time
   */
  executionDate: string;

  /** Дата обработки операции */
  operationProcessingDate: string;

  /** Место совершения операции */
  merchantCity: string;

  /** Наименование торговой точки */
  merchantName: string;

  /** MCC-код */
  merchantCategoryCode: string;

  /** Направление операции */
  direction: "DEBIT" | "CREDIT";

  /** Тип операции */
  operationType: string;

  /** Описание операции */
  description: string;

  /** Сумма операции в валюте операции */
  operationAmount: number;

  /** Валюта операции */
  operationCurrency: string;

  /** Сумма проведения по счету */
  accountAmount?: number;

  /** Валюта проведения по счету */
  accountCurrency?: string;

  /** Комиссия банка */
  transactionCommission: number;

  /** Валюта комиссии банка */
  transactionCommissionCurrency: string;
}

/**
 * Данные по операциям на бизнес-карте
 */
export interface CardOperationsResponse {
  /**
   * Дата формирования списка операций выписки
   * @format date
   */
  cardOperationListCreateDate: string;

  /**
   * Маскированный номер бизнес-карты
   * @example 123456******1234
   */
  maskedCardNumber?: string;

  /** ФИО Держателя бизнес-карты */
  holderFullName?: string;

  /** Наименование платёжной системы */
  paymentSystem?: string;

  /** Полное наименование категории карты */
  cardDescription?: string;

  /** Валюта счета бизнес-карты */
  currency?: string;

  /**
   * Начальная дата периода списка операций
   * @format date
   */
  cardOperationBeginDate?: string;

  /**
   * Конечная дата периода списка операций
   * @format date
   */
  cardOperationEndDate?: string;

  /** Список операций по карте */
  operations: CardOperation[];
}

/**
 * Страница с заявками клиента
 */
export interface ApplicationPage {
  content?: BaseApplication[];
  pageable?: PageableObject;

  /** @format int64 */
  total?: number;
  last?: boolean;

  /** @format int32 */
  totalPages?: number;

  /** @format int64 */
  totalElements?: number;
  first?: boolean;

  /** @format int32 */
  size?: number;

  /** @format int32 */
  number?: number;
  sort?: SortObject[];

  /** @format int32 */
  numberOfElements?: number;
  empty?: boolean;
}

export interface BaseApplication {
  /**
   * Идентификатор заявки
   * @format uuid
   * @example a195b8ff-b3db-4a00-b066-d2c2257d0864
   */
  id: string;

  /**
   * Идентификатор клиента
   * @format uuid
   * @example a195b8ff-b3db-4a00-b066-d2c2257d0865
   */
  clientId?: string;

  /**
   * Дата создания драфта
   * @format date-time
   */
  createdAt?: string;

  /**
   * Дата последнего обновления драфта
   * @format date-time
   */
  updatedAt?: string;

  /**
   * Статус заявки
   * @example ON_CONFIRMATION
   */
  status?:
    | "NEW"
    | "DRAFT"
    | "ON_CONFIRMATION"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "SENT_TO_CRM"
    | "SENT_TO_PROCESSING"
    | "SENT_TO_VERIFICATION"
    | "ON_VERIFICATION"
    | "DECLINED"
    | "REGISTERED_IN_CRM"
    | "COMPLETED"
    | "ERROR";

  /**
   * Тип заявки
   * @example BUSINESS_CARD_APPLICATION
   */
  type?:
    | "BUSINESS_CARD_APPLICATION"
    | "SELF_ENCASHMENT_APPLICATION"
    | "LIMITS_APPLICATION"
    | "CHANGE_PIN_APPLICATION"
    | "LOCK_CLOSE_APPLICATION"
    | "TRANSFER_BETWEEN_CARDS_APPLICATION";

  /**
   * Подписано первой подписью
   * @example true
   */
  clientFirstSign?: boolean;

  /**
   * Подписано второй подписью
   * @example false
   */
  clientSecondSign?: boolean;

  /**
   * Текст ошибки при статусе ERROR
   * @example Ошибка при получении данных из CRM
   */
  errorDescription?: string;

  /**
   * Краткое наименование клиента
   * @example ООО "Рога и копыта"
   */
  clientShortName?: string;

  /**
   * ИНН клиента
   * @example 123456789012
   */
  clientInn?: string;

  /**
   * Код отделения банка
   * @example 3205
   */
  bankBranchCode?: string;

  /**
   * ФИО держателя карты
   * @example Иванов Иван Иванович
   */
  holderFullName?: string;

  /**
   * Номер счета привязанной бизнес карты
   * @example 47423810835000024948
   */
  accountNumber?: string;

  /**
   * Маскированный номер карты
   * @example 5555 55** **** 5555
   */
  maskedCardNumber?: string;

  /**
   * Идентификатор тарифа бизнес карты
   * @format uuid
   * @example 08330bdd-545e-4c1b-a812-5b2e7aa4e5f8
   */
  tariffId?: string;

  /**
   * Название тарифного плана бизнес-карты
   * @example Самый лучший тариф
   */
  tariffTitle?: string;

  /**
   * Код платежной системы
   * @example MIR
   */
  paySystem?: string;

  /**
   * Название кода платежной системы
   * @example МИР
   */
  paySystemTitle?: string;

  /**
   * Тип носителя карты
   * @example PLASTIC
   */
  issueType?: string;

  /**
   * Название типа носителя карты
   * @example Пластиковая карта
   */
  issueTypeTitle?: string;
}

/**
 * Список делегатов клиента
 */
export interface DelegateResponse {
  delegates: Delegate[];
}

/**
 * Филиал клиента
 */
export interface Branch {
  /**
   * Индетификатор филиала
   * @format uuid
   * @example 8f6df882-5974-4869-988f-a0f675732abc
   */
  id: string;

  /**
   * Наименование филиала
   * @example Филиал москва [8295]
   */
  branchName: string;

  /**
   * Адрес филиала
   * @example 109145, г. Москва, просп. Лермонтовский, д. 2, корп. 1.
   */
  address: string;

  /**
   * Широта филиала
   * @example 55.703961
   */
  latitude?: string;

  /**
   * Долгота филиала
   * @example 37.84481
   */
  longitude?: string;
}

/**
 * Филиал клиента
 */
export interface BranchResponse {
  /** Филиал клиента */
  branch: Branch;
}

/**
 * Предложенные значения адресов
 */
export interface Address {
  /** Полный адрес */
  fullAddress: string;

  /** Данные адреса */
  fields: AddressFields;
}

/**
 * Данные адреса
 */
export interface AddressFields {
  /** Страна */
  country?: string;

  /** Код региона */
  region?: string;

  /** Населённый пункт */
  populationCenter?: string;

  /** Улица */
  street?: string;

  /** Дом */
  house?: string;

  /** Корпус */
  building?: string;

  /** Строение */
  housing?: string;

  /** Квартира */
  flat?: string;
}

/**
 * Список предлагаемых адресов
 */
export interface AddressListResponse {
  addresses: Address[];
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис ms-business-cards
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://ms-business-cards.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Бизнес-карты, https://sdlc.go.rshbank.ru/jira/projects/OB_BCARD <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=132977899)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Создание заявки на Бизнес-карту
     * @name UpdateApplication
     * @summary Обновление заявки на Бизнес-карту
     * @request PUT:/api/cards/v1/external/application/update
     * @secure
     */
    updateApplication: (
      data: BusinessCardApplicationRequest,
      params: RequestParams = {}
    ) =>
      this.request<BusinessCardApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/application/update`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на Бизнес-карту
     * @name ConfirmApplication
     * @summary Передача заявки на Бизнес-карту на подписание
     * @request PUT:/api/cards/v1/external/application/confirm
     * @secure
     */
    confirmApplication: (
      data: BusinessCardApplicationRequest,
      params: RequestParams = {}
    ) =>
      this.request<BusinessCardApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/application/confirm`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на перевод денежных средств по номеру банковской карты
     * @name SignTransferBetweenCardsApplication
     * @summary Подписание заявки на перевод денежных средств по номеру банковской карты с использованием реквизитов бизнес-карты
     * @request POST:/api/cards/v1/external/transfer-between-cards/application/sign
     * @secure
     */
    signTransferBetweenCardsApplication: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<TransferBetweenCardsApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/transfer-between-cards/application/sign`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на перевод денежных средств по номеру банковской карты
     * @name SendTransferBetweenCardsApplication
     * @summary Оправка заявки на перевод денежных средств по номеру банковской карты с использованием реквизитов бизнес-карты
     * @request POST:/api/cards/v1/external/transfer-between-cards/application/send
     * @secure
     */
    sendTransferBetweenCardsApplication: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/cards/v1/external/transfer-between-cards/application/send`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на перевод денежных средств по номеру банковской карты
     * @name ConfirmTransferBetweenCardsApplication
     * @summary Передача на подписание заявки на перевод денежных средств по номеру банковской карты с использованием реквизитов бизнес-карты
     * @request POST:/api/cards/v1/external/transfer-between-cards/application/confirm
     * @secure
     */
    confirmTransferBetweenCardsApplication: (
      data: TransferBetweenCardsApplicationRequest,
      params: RequestParams = {}
    ) =>
      this.request<TransferBetweenCardsApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/transfer-between-cards/application/confirm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на перевод денежных средств по номеру банковской карты
     * @name CheckTransferBetweenCards
     * @summary Получение размера комиссии по заявке на перевод денежных средств по номеру банковской карты с использованием реквизитов бизнес-карты
     * @request POST:/api/cards/v1/external/transfer-between-cards/application/check
     * @secure
     */
    checkTransferBetweenCards: (
      data: CheckTransferBetweenCardsRequest,
      params: RequestParams = {}
    ) =>
      this.request<CheckTransferBetweenCardsResponse, ErrorMessage>({
        path: `/api/cards/v1/external/transfer-between-cards/application/check`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подключение услуги "Самоинкассация"
     * @name SignSelfEncashmentApplication
     * @summary Подписание заявки на подключение самоинкассации
     * @request POST:/api/cards/v1/external/self-encashment/application/sign
     * @secure
     */
    signSelfEncashmentApplication: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<SelfEncashmentApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/self-encashment/application/sign`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подключение услуги "Самоинкассация"
     * @name SendEncashmentApplication
     * @summary Оправка заявки на услугу самоинкосации в CRM
     * @request POST:/api/cards/v1/external/self-encashment/application/send/{appId}
     * @secure
     */
    sendEncashmentApplication: (appId: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/cards/v1/external/self-encashment/application/send/${appId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подключение услуги "Самоинкассация"
     * @name EnableSelfEncashmentApplication
     * @summary Передача заявки на самоинкассацию на подписание
     * @request POST:/api/cards/v1/external/self-encashment/application/enable
     * @secure
     */
    enableSelfEncashmentApplication: (
      data: SelfEncashmentApplicationRequest,
      params: RequestParams = {}
    ) =>
      this.request<SelfEncashmentApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/self-encashment/application/enable`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подключение услуги "Самоинкассация"
     * @name DisableSelfEncashmentApplication
     * @summary Отключение услуги самоинкассации
     * @request POST:/api/cards/v1/external/self-encashment/application/disable
     * @secure
     */
    disableSelfEncashmentApplication: (
      data: SelfEncashmentApplicationRequest,
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorMessage>({
        path: `/api/cards/v1/external/self-encashment/application/disable`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на блокировку/закрытие бизнес-карты
     * @name SignLockCloseApplication
     * @summary Подписание заявки на блокировку/закрытие карты
     * @request POST:/api/cards/v1/external/lock-close/application/sign
     * @secure
     */
    signLockCloseApplication: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<LockCloseApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/lock-close/application/sign`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на блокировку/закрытие бизнес-карты
     * @name SendLockCloseApplication
     * @summary Оправка заявки на блокировку/закрытие карты
     * @request POST:/api/cards/v1/external/lock-close/application/send
     * @secure
     */
    sendLockCloseApplication: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/cards/v1/external/lock-close/application/send`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на блокировку/закрытие бизнес-карты
     * @name ConfirmLockCloseApplication
     * @summary Передача заявки на блокировку/закрытие карты на подписание
     * @request POST:/api/cards/v1/external/lock-close/application/confirm
     * @secure
     */
    confirmLockCloseApplication: (
      data: LockCloseApplicationRequest,
      params: RequestParams = {}
    ) =>
      this.request<LockCloseApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/lock-close/application/confirm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на изменение лимитов по Бизнес-карте
     * @name SignLimitsApplication
     * @summary Подписание заявки на изменение лимитов по карте
     * @request POST:/api/cards/v1/external/limits/application/sign
     * @secure
     */
    signLimitsApplication: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<LimitsApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/limits/application/sign`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на изменение лимитов по Бизнес-карте
     * @name SendLimitsApplication
     * @summary Оправка заявки на изменение лимитов по Бизнес-карте
     * @request POST:/api/cards/v1/external/limits/application/send
     * @secure
     */
    sendLimitsApplication: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/cards/v1/external/limits/application/send`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на изменение лимитов по Бизнес-карте
     * @name ConfirmLimitsApplication
     * @summary Передача заявки на изменение лимитов по карте на подписание
     * @request POST:/api/cards/v1/external/limits/application/confirm
     * @secure
     */
    confirmLimitsApplication: (
      data: LimitsApplicationRequest,
      params: RequestParams = {}
    ) =>
      this.request<LimitsApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/limits/application/confirm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на изменение ПИН-кода по Бизнес-карте
     * @name SendChangePinApplication
     * @summary Отправка в работу заявки на изменение ПИН-кода
     * @request POST:/api/cards/v1/external/change-pin/application/send
     * @secure
     */
    sendChangePinApplication: (
      data: ChangePinApplicationSendRequest,
      params: RequestParams = {}
    ) =>
      this.request<ChangePinApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/change-pin/application/send`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на изменение ПИН-кода по Бизнес-карте
     * @name CreateChangePinApplication
     * @summary Создание заявки на изменение ПИН-кода
     * @request POST:/api/cards/v1/external/change-pin/application/create
     * @secure
     */
    createChangePinApplication: (
      data: ChangePinApplicationRequest,
      params: RequestParams = {}
    ) =>
      this.request<ChangePinApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/change-pin/application/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с вложениями заявок на Бизнес-карту для клиента
     * @name UploadAttachment
     * @summary Загрузка вложения для заявки на Бизнес-карту
     * @request POST:/api/cards/v1/external/attachment/upload
     * @secure
     */
    uploadAttachment: (
      query: { applicationId: string },
      data: { file: File },
      params: RequestParams = {}
    ) =>
      this.request<AttachmentLoadResponse, ErrorMessage>({
        path: `/api/cards/v1/external/attachment/upload`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на Бизнес-карту
     * @name SignApplication
     * @summary Подписание заявки на Бизнес-карту
     * @request POST:/api/cards/v1/external/application/sign
     * @secure
     */
    signApplication: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<BusinessCardApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/application/sign`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на Бизнес-карту
     * @name SendApplication
     * @summary Отправка в работу подписаной заявки
     * @request POST:/api/cards/v1/external/application/send/{applicationId}
     * @secure
     */
    sendApplication: (applicationId: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/cards/v1/external/application/send/${applicationId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на Бизнес-карту
     * @name CreateApplication
     * @summary Создание заявки на Бизнес-карту
     * @request POST:/api/cards/v1/external/application/create
     * @secure
     */
    createApplication: (
      data: BusinessCardApplicationRequest,
      params: RequestParams = {}
    ) =>
      this.request<BusinessCardApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/application/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на перевод денежных средств по номеру банковской карты
     * @name GetTransferBetweenCardsApplication
     * @summary Получение заявки по идентификатору
     * @request GET:/api/cards/v1/external/transfer-between-cards/application
     * @secure
     */
    getTransferBetweenCardsApplication: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<TransferBetweenCardsApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/transfer-between-cards/application`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на перевод денежных средств по номеру банковской карты
     * @name GetTransferBetweenCardsApplicationStatus
     * @summary Получение статуса документа
     * @request GET:/api/cards/v1/external/transfer-between-cards/application/status
     * @secure
     */
    getTransferBetweenCardsApplicationStatus: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<ApplicationStatusResponse, ErrorMessage>({
        path: `/api/cards/v1/external/transfer-between-cards/application/status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ресурс тарифа
     * @name GetTariffs
     * @summary Получение списка тарифов по бизнес картам
     * @request GET:/api/cards/v1/external/tariffs
     * @secure
     */
    getTariffs: (query: { archived: boolean }, params: RequestParams = {}) =>
      this.request<TariffResponse, ErrorMessage>({
        path: `/api/cards/v1/external/tariffs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ресурс тарифа
     * @name GetTariffById
     * @summary Получение тарифа по бизнес картам
     * @request GET:/api/cards/v1/external/tariffs/{tariffId}
     * @secure
     */
    getTariffById: (tariffId: string, params: RequestParams = {}) =>
      this.request<Tariff, ErrorMessage>({
        path: `/api/cards/v1/external/tariffs/${tariffId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ресурс тарифа
     * @name GetImage
     * @summary Получение изображения тарифа по бизнес картам
     * @request GET:/api/cards/v1/external/tariffs/image/{tariffId}
     * @secure
     */
    getImage: (
      tariffId: string,
      query?: { smallImage?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorMessage>({
        path: `/api/cards/v1/external/tariffs/image/${tariffId}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подключение услуги "Самоинкассация"
     * @name SelfEncashmentApplication
     * @summary Детализация заявки на самоинкассацию
     * @request GET:/api/cards/v1/external/self-encashment/application/{appId}
     * @secure
     */
    selfEncashmentApplication: (appId: string, params: RequestParams = {}) =>
      this.request<SelfEncashmentApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/self-encashment/application/${appId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подключение услуги "Самоинкассация"
     * @name GetSelfEncashmentApplicationStatus
     * @summary Получение статуса документа
     * @request GET:/api/cards/v1/external/self-encashment/application/status
     * @secure
     */
    getSelfEncashmentApplicationStatus: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<ApplicationStatusResponse, ErrorMessage>({
        path: `/api/cards/v1/external/self-encashment/application/status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подключение услуги "Самоинкассация"
     * @name EncashmentList
     * @summary Получение списка заявок на самоинкассацию
     * @request GET:/api/cards/v1/external/self-encashment/application/list
     * @secure
     */
    encashmentList: (
      query?: {
        statuses?: (
          | "NEW"
          | "DRAFT"
          | "ON_CONFIRMATION"
          | "PARTIALLY_SIGNED"
          | "SIGNED"
          | "SENT_TO_CRM"
          | "SENT_TO_PROCESSING"
          | "SENT_TO_VERIFICATION"
          | "ON_VERIFICATION"
          | "DECLINED"
          | "REGISTERED_IN_CRM"
          | "COMPLETED"
          | "ERROR"
        )[];
        from?: string;
        to?: string;
        sortDirection?: "ASC" | "DESC";
        types?: ("ENABLE" | "UPDATE" | "DISABLE")[];
        page?: number;
        size?: number;
        sort?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SelfEncashmentApplicationPage, ErrorMessage>({
        path: `/api/cards/v1/external/self-encashment/application/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подключение услуги "Самоинкассация"
     * @name GetAccountsForCreditingFunds
     * @summary Получение списка счетов клиента для зачисления денежных средств
     * @request GET:/api/cards/v1/external/self-encashment/application/funds-accounts/list
     * @secure
     */
    getAccountsForCreditingFunds: (params: RequestParams = {}) =>
      this.request<AccountResponse, ErrorMessage>({
        path: `/api/cards/v1/external/self-encashment/application/funds-accounts/list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подключение услуги "Самоинкассация"
     * @name GetSelfEncashmentAccounts
     * @summary Получение списка счетов клиента с данными по самоинкассации
     * @request GET:/api/cards/v1/external/self-encashment/accounts/list
     * @secure
     */
    getSelfEncashmentAccounts: (params: RequestParams = {}) =>
      this.request<SelfEncashmentAccountResponse, ErrorMessage>({
        path: `/api/cards/v1/external/self-encashment/accounts/list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ресурс тарифа
     * @name GetPaymentSystems
     * @summary Получение списка платежных систем
     * @request GET:/api/cards/v1/external/payment-systems
     * @secure
     */
    getPaymentSystems: (params: RequestParams = {}) =>
      this.request<PaymentSystemResponse, ErrorMessage>({
        path: `/api/cards/v1/external/payment-systems`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на блокировку/закрытие бизнес-карты
     * @name GetLockCloseApplication
     * @summary Получение заявки по идентификатору
     * @request GET:/api/cards/v1/external/lock-close/application
     * @secure
     */
    getLockCloseApplication: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<LockCloseApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/lock-close/application`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на блокировку/закрытие бизнес-карты
     * @name GetLockCloseApplicationStatus
     * @summary Получение статуса документа
     * @request GET:/api/cards/v1/external/lock-close/application/status
     * @secure
     */
    getLockCloseApplicationStatus: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<ApplicationStatusResponse, ErrorMessage>({
        path: `/api/cards/v1/external/lock-close/application/status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на изменение лимитов по Бизнес-карте
     * @name GetLimitsApplication
     * @summary Получение заявки по идентификатору
     * @request GET:/api/cards/v1/external/limits/application
     * @secure
     */
    getLimitsApplication: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<LimitsApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/limits/application`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на изменение лимитов по Бизнес-карте
     * @name GetLimitsApplicationStatus
     * @summary Получение статуса документа
     * @request GET:/api/cards/v1/external/limits/application/status
     * @secure
     */
    getLimitsApplicationStatus: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<ApplicationStatusResponse, ErrorMessage>({
        path: `/api/cards/v1/external/limits/application/status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ресурс тарифа
     * @name GetIssueTypes
     * @summary Получение типов карты по платежным системам
     * @request GET:/api/cards/v1/external/issue-types
     * @secure
     */
    getIssueTypes: (params: RequestParams = {}) =>
      this.request<IssueTypeResponse, ErrorMessage>({
        path: `/api/cards/v1/external/issue-types`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetSignData
     * @summary Текущие данные по подписанию
     * @request GET:/api/cards/v1/external/confirmation/sign-data
     * @secure
     */
    getSignData: (params: RequestParams = {}) =>
      this.request<SignDataResponse, ErrorMessage>({
        path: `/api/cards/v1/external/confirmation/sign-data`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetTransferBetweenCardsApplicationDocumentCcb
     * @summary ККБ заявки на перевод денежных средств по номеру банковской карты с использованием реквизитов бизнес-карты
     * @request GET:/api/cards/v1/external/confirmation/document-ccb/transfer-between-cards-application
     * @secure
     */
    getTransferBetweenCardsApplicationDocumentCcb: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<
        TransferBetweenCardsApplicationDocumentCcbResponse,
        ErrorMessage
      >({
        path: `/api/cards/v1/external/confirmation/document-ccb/transfer-between-cards-application`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetSelfEncashmentApplicationDocumentCcb
     * @summary ККБ заявки на подключение самоинкассации
     * @request GET:/api/cards/v1/external/confirmation/document-ccb/self-encashment-application
     * @secure
     */
    getSelfEncashmentApplicationDocumentCcb: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<SelfEncashmentApplicationDocumentCcbResponse, ErrorMessage>({
        path: `/api/cards/v1/external/confirmation/document-ccb/self-encashment-application`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetLockCloseApplicationDocumentCcb
     * @summary ККБ заявки на блокировку/закрытие бизнес-карты
     * @request GET:/api/cards/v1/external/confirmation/document-ccb/lock-close-application
     * @secure
     */
    getLockCloseApplicationDocumentCcb: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<LockCloseApplicationDocumentCcbResponse, ErrorMessage>({
        path: `/api/cards/v1/external/confirmation/document-ccb/lock-close-application`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetLimitsApplicationDocumentCcb
     * @summary ККБ заявки на изменение лимитов по бизнес-карте
     * @request GET:/api/cards/v1/external/confirmation/document-ccb/limits-application
     * @secure
     */
    getLimitsApplicationDocumentCcb: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<LimitsApplicationDocumentCcbResponse, ErrorMessage>({
        path: `/api/cards/v1/external/confirmation/document-ccb/limits-application`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetBusinessCardApplicationDocumentCcb
     * @summary ККБ заявки на бизнес-карту
     * @request GET:/api/cards/v1/external/confirmation/document-ccb/business-card-application
     * @secure
     */
    getBusinessCardApplicationDocumentCcb: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<BusinessCardApplicationDocumentCcbResponse, ErrorMessage>({
        path: `/api/cards/v1/external/confirmation/document-ccb/business-card-application`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из МС Подтверждения
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/cards/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, ErrorMessage>({
        path: `/api/cards/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Бизнес-карты клиента
     * @name GetCardsForTransferBetweenCards
     * @summary Получение списка бизнес-карт для которых доступен перевод по номеру карты
     * @request GET:/api/cards/v1/external/client-cards/transfer-between-cards
     * @secure
     */
    getCardsForTransferBetweenCards: (params: RequestParams = {}) =>
      this.request<CardsForTransferBetweenCards, ErrorMessage>({
        path: `/api/cards/v1/external/client-cards/transfer-between-cards`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Бизнес-карты клиента
     * @name CardsList
     * @summary Получение списка бизнес-карт
     * @request GET:/api/cards/v1/external/client-cards/list
     * @secure
     */
    cardsList: (
      query?: {
        page?: number;
        size?: number;
        sort?: string[];
        closed?: boolean;
        accountId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<CardsPage, ErrorMessage>({
        path: `/api/cards/v1/external/client-cards/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Бизнес-карты клиента
     * @name GetCardLimits
     * @summary Получение лимитов по карте
     * @request GET:/api/cards/v1/external/client-cards/limits
     * @secure
     */
    getCardLimits: (query: { cardId: string }, params: RequestParams = {}) =>
      this.request<CardLimitsResponse, ErrorMessage>({
        path: `/api/cards/v1/external/client-cards/limits`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Бизнес-карты клиента
     * @name GetCardDetails
     * @summary Получение зашифрованных данных по карте
     * @request GET:/api/cards/v1/external/client-cards/details
     * @secure
     */
    getCardDetails: (
      query: { cardId: string; encryptionKey: string },
      params: RequestParams = {}
    ) =>
      this.request<CardDetailsResponse, ErrorMessage>({
        path: `/api/cards/v1/external/client-cards/details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Бизнес-карты клиента
     * @name GetCardPropertiesByCardNumber
     * @summary Получение идентификатора карты и типа перевода по номеру карты
     * @request GET:/api/cards/v1/external/client-cards/card-properties
     * @secure
     */
    getCardPropertiesByCardNumber: (
      query: { cardNumber: string },
      params: RequestParams = {}
    ) =>
      this.request<GetCardPropertiesByCardNumberResponse, ErrorMessage>({
        path: `/api/cards/v1/external/client-cards/card-properties`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Действия выполняемые при входе в функциональность бизнес-карт
     * @name CheckDelegate
     * @summary Получение списка заявок
     * @request GET:/api/cards/v1/external/check-delegate
     * @secure
     */
    checkDelegate: (params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/cards/v1/external/check-delegate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на изменение ПИН-кода по Бизнес-карте
     * @name GetChangePinInfo
     * @summary Получение идентификатора и открытого RSA-ключа для шифрования ПИН-кода
     * @request GET:/api/cards/v1/external/change-pin/info
     * @secure
     */
    getChangePinInfo: (params: RequestParams = {}) =>
      this.request<ChangePinInfo, ErrorMessage>({
        path: `/api/cards/v1/external/change-pin/info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на изменение ПИН-кода по Бизнес-карте
     * @name GetChangePinApplication
     * @summary Получение заявки на изменение ПИН-кода по идентификатору
     * @request GET:/api/cards/v1/external/change-pin/application
     * @secure
     */
    getChangePinApplication: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<ChangePinApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/change-pin/application`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на изменение ПИН-кода по Бизнес-карте
     * @name GetChangePinApplicationStatus
     * @summary Получение статуса документа
     * @request GET:/api/cards/v1/external/change-pin/application/status
     * @secure
     */
    getChangePinApplicationStatus: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<ApplicationStatusResponse, ErrorMessage>({
        path: `/api/cards/v1/external/change-pin/application/status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификаты клиента
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/cards/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, ErrorMessage>({
        path: `/api/cards/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Список операций по Бизнес-карте клиента
     * @name GetCardOperationsListFile
     * @summary Получение операций по карте
     * @request GET:/api/cards/v1/external/card-operations/file
     * @secure
     */
    getCardOperationsListFile: (
      query: {
        cardId: string;
        beginDate: string;
        endDate: string;
        fileType: string;
        direction?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorMessage>({
        path: `/api/cards/v1/external/card-operations/file`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Список операций по Бизнес-карте клиента
     * @name GetCardOperationsFeed
     * @summary Получение операций по карте
     * @request GET:/api/cards/v1/external/card-operations/feed
     * @secure
     */
    getCardOperationsFeed: (
      query: { cardId: string; operationsCount: string },
      params: RequestParams = {}
    ) =>
      this.request<CardOperationsResponse, ErrorMessage>({
        path: `/api/cards/v1/external/card-operations/feed`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с вложениями заявок на Бизнес-карту для клиента
     * @name CheckAttachments
     * @summary Проверка статуса вложений заявок на Бизнес-карту
     * @request GET:/api/cards/v1/external/attachment/check
     * @secure
     */
    checkAttachments: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<AttachmentLoadResponse, ErrorMessage>({
        path: `/api/cards/v1/external/attachment/check`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Список заявок клиента
     * @name GetApplicationPage
     * @summary Получение списка заявок
     * @request GET:/api/cards/v1/external/applications/list
     * @secure
     */
    getApplicationPage: (
      query?: {
        types?: (
          | "BUSINESS_CARD_APPLICATION"
          | "SELF_ENCASHMENT_APPLICATION"
          | "LIMITS_APPLICATION"
          | "CHANGE_PIN_APPLICATION"
          | "LOCK_CLOSE_APPLICATION"
          | "TRANSFER_BETWEEN_CARDS_APPLICATION"
        )[];
        statuses?: (
          | "NEW"
          | "DRAFT"
          | "ON_CONFIRMATION"
          | "PARTIALLY_SIGNED"
          | "SIGNED"
          | "SENT_TO_CRM"
          | "SENT_TO_PROCESSING"
          | "SENT_TO_VERIFICATION"
          | "ON_VERIFICATION"
          | "DECLINED"
          | "REGISTERED_IN_CRM"
          | "COMPLETED"
          | "ERROR"
        )[];
        cardHolderName?: string;
        from?: string;
        to?: string;
        sortDirection?: "ASC" | "DESC";
        page?: number;
        size?: number;
        sort?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ApplicationPage, ErrorMessage>({
        path: `/api/cards/v1/external/applications/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на Бизнес-карту
     * @name GetBusinessCardApplication
     * @summary Получение заявки по идентификатору
     * @request GET:/api/cards/v1/external/application
     * @secure
     */
    getBusinessCardApplication: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<BusinessCardApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/application`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на Бизнес-карту
     * @name GetApplicationStatus
     * @summary Получение статуса документа
     * @request GET:/api/cards/v1/external/application/status
     * @secure
     */
    getApplicationStatus: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<ApplicationStatusResponse, ErrorMessage>({
        path: `/api/cards/v1/external/application/status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на Бизнес-карту
     * @name GetDraft
     * @summary Получение последнего заполненного драфта заявки
     * @request GET:/api/cards/v1/external/application/draft
     * @secure
     */
    getDraft: (params: RequestParams = {}) =>
      this.request<BusinessCardApplicationResponse, ErrorMessage>({
        path: `/api/cards/v1/external/application/draft`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на Бизнес-карту
     * @name GetDelegates
     * @summary Получение списка уполномоченых лиц клиента
     * @request GET:/api/cards/v1/external/application/delegates
     * @secure
     */
    getDelegates: (params: RequestParams = {}) =>
      this.request<DelegateResponse, ErrorMessage>({
        path: `/api/cards/v1/external/application/delegates`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на Бизнес-карту
     * @name GetBranch
     * @summary Получение филиала клиента
     * @request GET:/api/cards/v1/external/application/branch
     * @secure
     */
    getBranch: (params: RequestParams = {}) =>
      this.request<BranchResponse, ErrorMessage>({
        path: `/api/cards/v1/external/application/branch`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на Бизнес-карту
     * @name GetAddresses
     * @summary Получение списка подходящих адресов
     * @request GET:/api/cards/v1/external/application/addresses
     * @secure
     */
    getAddresses: (
      query: { estimatedAddress: string; addressesCount?: string },
      params: RequestParams = {}
    ) =>
      this.request<AddressListResponse, ErrorMessage>({
        path: `/api/cards/v1/external/application/addresses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Создание заявки на Бизнес-карту
     * @name GetAccounts
     * @summary Получение списка счетов доступных для бизнес карты
     * @request GET:/api/cards/v1/external/application/accounts
     * @secure
     */
    getAccounts: (params: RequestParams = {}) =>
      this.request<AccountResponse, ErrorMessage>({
        path: `/api/cards/v1/external/application/accounts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с вложениями заявок на Бизнес-карту для клиента
     * @name DeleteAttachment
     * @summary Удаление вложений заявок на Бизнес-карту
     * @request DELETE:/api/cards/v1/external/attachment/delete
     * @secure
     */
    deleteAttachment: (
      query: { attachmentId: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/cards/v1/external/attachment/delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
